import React__default, { useRef } from 'react';
import { Input, Collapse } from 'reactstrap';
import useClickAway from '../../../../../../node_modules/.pnpm/react-use@17.6.0_react-dom@19.0.0_react@19.0.0/node_modules/react-use/esm/useClickAway.js';

const FormInputSearchDropdownCore = (props) => {
    const { tag, name, className, type, autoComplete, disabled, placeholder, disablePaste, onFocus, onBlur, options, field, collapseOpen, setCollapseOpen, exposeSeparateFieldValue, setValue } = props;
    const containerRef = useRef(null);
    useClickAway(containerRef, () => {
        setCollapseOpen(false);
    });
    const onOptionClick = (code, fullObject) => {
        if (!!exposeSeparateFieldValue && !!fullObject) {
            exposeSeparateFieldValue(name, fullObject);
        }
        if (!!setValue) {
            setValue(name, code);
        }
        setCollapseOpen(false);
    };
    return (React__default.createElement("div", { ref: containerRef, className: "position-relative" },
        React__default.createElement(Input, { id: `form-builder-input-${name}-${tag}`, ...field, "data-testid": 'form-input-' + name, value: field.value, type: type || 'text', onFocus: onFocus, onBlur: onBlur, onChange: e => field.onChange(e.target.value), onClick: () => setCollapseOpen(true), className: `${className || ''} ${!!field.value ? 'input--filled' : ''}`, autoComplete: autoComplete, disabled: disabled, placeholder: placeholder, onPaste: (e) => {
                if (disablePaste) {
                    e.preventDefault();
                }
            } }),
        React__default.createElement(Collapse, { className: "form-input__collapse", isOpen: !!options && options.length > 0 && collapseOpen }, options.map(({ code, label: optionLabel, fullObject, indexer }) => (React__default.createElement("div", { key: indexer || code || JSON.stringify(fullObject), className: "form-input__collapse__option", onClick: () => onOptionClick(code, fullObject) }, optionLabel))))));
};

export { FormInputSearchDropdownCore as default };
//# sourceMappingURL=FormInputSearchDropdownCore.js.map
